import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayoutCollapseService } from './services/layout-collapse.service';

@Component({
  selector: 's18-root',
  templateUrl: './app.component.html',
  styles: []
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'ggk-web';
  footerCollapsed = false;
  private sub: Subscription;

  constructor(private layoutCollapse: LayoutCollapseService) {}

  ngOnInit(): void {
    this.sub = this.layoutCollapse.collapsed$.subscribe(c => this.footerCollapsed = c);
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }
}
